import classNames from 'classnames';
import { autobind } from 'core-decorators';
import PropTypes from 'prop-types';
import React from 'react';
import Popup from '/@/components/popup';
import { isMobile } from '/@/utils';
import styles from './styles.module.css';

@autobind
export default class Tooltip extends React.Component {
    static propTypes = {
        text: PropTypes.string,
        largeText: PropTypes.bool,
    };

    state = {
        show: false,
    };

    hideDescription() {
        this.setState({ show: false });
    }

    showDescription() {
        this.setState({ show: true });
    }

    render() {
        if (isMobile()) {
            return (
                <div>
                    <div onClick={this.showDescription}>{this.props.children}</div>
                    <Popup visible={this.state.show} onClose={this.hideDescription} className={styles.modal}>
                        {this.props.text && <div>{this.props.text}</div>}
                    </Popup>
                </div>
            );
        }
        return (
            <div className={styles.root} onMouseEnter={this.showDescription} onMouseLeave={this.hideDescription}>
                {this.props.text && (
                    <div
                        className={
                            !this.state.show
                                ? styles.tooltipBox
                                : this.props.largeText
                                  ? classNames(styles.tooltipBoxForLargeText, styles.visible)
                                  : classNames(styles.tooltipBox, styles.visible)
                        }
                    >
                        {this.props.text}
                    </div>
                )}
                <div>{this.props.children}</div>
            </div>
        );
    }
}
